export default __webpack_public_path__ + "static/media/watermark.6bb3121b.png";